<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div>
      <span :class="{'has-error':errors.pointsValue}">
        balance to <input :value="pointsValue" class="form-control input-numeric" name="pointsValue" @input="handleChange">
      </span>
    </div>
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,
    
    props: {
      id: String,
      // Fundamentally numbers, but often stored as a string
      pointsValue: [Number, String],
    },
    methods: {
      validate: function() {
        this.errors = {};
        if (!this.isNumber(this.pointsValue)) {
          this.errors.pointsValue = "Please enter a number to set the point balance to.";
        }
        
        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
